module.exports = __webpack_public_path__ + "img/good-vibes-w-elixer_400x124.a42e66fc.png";